import React, { useCallback, useContext, useMemo } from 'react';
import { TranslatorContext } from '@jutro/locale';
import { Button, CurrencyValue, Link } from '@jutro/components';
import { useHistory } from 'react-router-dom';
import { SgRenewalUpgradeAccordion } from 'saga-cep-specific-components';
import { SgRenewalUtil, SgWebchatUtil } from 'saga-modules';
import messages from './SgRenewalProposalTile.messages';

function SgRenewalProposalTile(props) {
    const {
        id,
        renewal
    } = props;

    const history = useHistory();
    const translator = useContext(TranslatorContext);

    const coverLevelName = useMemo(() => {
        return SgRenewalUtil.getCoverLevelName(renewal);
    }, [renewal]);

    const toRenewalFlow = useCallback(() => {
        history.push('/renewal', {
            policyNumber: renewal.jobNumber,
            productCode: renewal.productCode
        });
    }, [renewal]);

    const trackChat = useCallback((event) => {
        if (event) {
            event.preventDefault();
        }
        SgWebchatUtil.trackChat();
    }, []);

    return (
        <div className="sg-policy-tile sg-renewal-policy-tile">
            <div className={`sg-policy-tile-details-container ${renewal.productCode}`}>
                {renewal.isOnAutoRenewal
                    ? (
                        <p className="sg-renewal-policy-automatically-header">
                            <span>{translator(messages.NoNeedToContact)}</span>
                            &nbsp;
                            <span>{translator(messages.AutoRenew, { days: renewal.daysTillEffective })}</span>
                        </p>
                    ) : (
                        <p className="sg-renewal-policy-automatically-header">
                            {translator(messages[`${renewal.productCode}RenewalIsReady`])}
                        </p>
                    )
                }
                <h3 className="sg-policy-description">{renewal.description}</h3>
                <h3>{coverLevelName}</h3>
                { renewal.showMigratedRenewalBanner
                    ? (
                        <div className="sg-renewal-migration-banner" id="sgMigrationRenewalBanner">
                            <span>
                                <p id="webchatMessageRenewalProposal">
                                    {translator(messages.MigrationBannerText)}
                                    <Link
                                        href="/"
                                        id="webchatlinkRenewalProposal"
                                        onClick={trackChat}
                                        className="saga-intercom"
                                    >
                                        {translator(messages.MigrationBannerTextWebChat)}
                                    </Link>
                                </p>
                            </span>
                        </div>
                    ) : ''}
            </div>
            <div className="sg-policy-tile-button-container">
                <h3 className="sg-total-price-and-title">
                    <span className="sg-price-title">{translator(messages.TotalPrice)}</span>
                    <span className="sg-price-amount">
                        <CurrencyValue
                            currency="gbp"
                            currencyDisplay="symbol"
                            id="CurrencyValue"
                            placeholder="-"
                            showFractions
                            showGrouping
                            tag="div"
                            value={renewal.premium.amount}
                        />
                    </span>
                </h3>
                <Button id={`renewOrReviewBtn_${id}`} className="sgButton sgTransactionButton" onClick={toRenewalFlow}>
                    {renewal.isCashChequePayment ? translator(messages.ViewDetails) : translator(messages.Review)}
                </Button>
            </div>
            {renewal.canUpgradeCoverLevel ? <SgRenewalUpgradeAccordion renewal={renewal} id={id} /> : ''}
            <div className="sg-clear-both" />
        </div>
    );
}

export default SgRenewalProposalTile;
